import React from "react";

import { SubscriptionEstimateComplex } from "@packages/client";
import { Typography } from "@packages/ds";

import * as O from "src/organization/pages/billing/components/Overview/BillingOverview.styles";

type MeasureRowProps = {
  label: string;
  unitPrice: string;
  quantity: string;
  total: string;
  displayProjection: string;
  isEmbedded: false | SubscriptionEstimateComplex | undefined;
  currentSpend: string;
};

const MeasureRow = ({
  label,
  unitPrice,
  quantity,
  total,
  displayProjection,
  isEmbedded,
  currentSpend
}: MeasureRowProps) => (
  <>
    <Typography.BodyText>{label}</Typography.BodyText>
    <O.BodyTextSubtle>{unitPrice}</O.BodyTextSubtle>
    <O.BodyTextSubtle>{quantity}</O.BodyTextSubtle>
    {displayProjection === "current" && (
      <O.BodyTextSubtle>{currentSpend}</O.BodyTextSubtle>
    )}
    <O.RightText $shouldRenderSpaced={!!isEmbedded}>{total}</O.RightText>
  </>
);
export default MeasureRow;
